// List of countries where billing address is typically required (due to AVS enforcement)
export const REQUIRES_ADDRESS_COUNTRIES = new Set([
  // European Union + UK
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',

  // North America
  'US',
  'CA',

  // Oceania
  'AU',
  'NZ',

  // Asia
  'JP',
  'SG',

  // South America
  'BR',
]);

export const US_CODE = 'US';

export function requiresAddressForCountry(code?: string): boolean {
  return !!code && REQUIRES_ADDRESS_COUNTRIES.has(code.toUpperCase());
}
